//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import Header from "~/content/data/header.json";
export default {
    name: "PageHeader",
    data() {
        return {};
    },
    computed: {
        ...mapState({
            page: (state) => state.pages.page,
        }),
        header: () => Header,
        theme() {
            if (this.page && this.page.header) return "navbar-" + (this.page.header.theme || "dark");
            return "navbar-dark";
        },
    },
    methods: {},
    created() {
        this.$router.beforeEach((to, from, next) => {
            if (to.name !== "slug") {
                window.location.assign(to.path.replace("/http", "http"));
                next(false);
            } else {
                next();
            }
        });
    },
};
